<div>
  <ng-template gstarComponentHost></ng-template>
</div>
